<template>
  <div class="custom-avatar-wrapper">
    <v-avatar
      :color="avatarColor"
      :size="avatarSize"
      :tile="isGroup"
      :class="{ 'custom-avatar-disabled': isDisabledOrDeleted }"
    >
      <v-icon v-if="isGroup && false" :style="`font-size: ${iconSize}px;`">
        mdi-account-group
      </v-icon>
      <span
        v-if="isGroup && true"
        :class="`${initialsColor}--text`"
        :style="`font-size: ${initialsSize}px;`"
      >
        <template v-if="userName">
          {{ userName.substring(0, 4).toUpperCase() }}
        </template>
      </span>

      <span
        v-else-if="!userAvatar"
        :class="`${initialsColor}--text`"
        :style="`font-size: ${initialsSize}px`"
      >
        <template v-if="userName">
          {{
            userName
              .split(' ')
              .map((n) => n[0])
              .join('')
              .substring(0, 3)
          }}
        </template>
      </span>
      <v-img v-else elevation="2" :src="userAvatar" />
    </v-avatar>
    <span v-if="isGroup && isDisabledOrDeleted" class="custom-avatar-diagonal">
    </span>

    <v-avatar
      v-if="userRole"
      :color="overlapAvatarColor"
      :size="overlapAvatarSize"
      :style="{
        'margin-left': `${-avatarSize / 2.5}px`,
        'margin-top': `${avatarSize / 1.5}px`,
        position: 'absolute',
      }"
    >
    </v-avatar>
    <!-- icono cargando, para grupos -->
    <v-icon
      v-if="overlapIconColor === 'loading'"
      class="spin loading-icon"
      :size="avatarSize / 1.5"
      color="primary"
      :style="{
        'margin-left': `${-avatarSize / 2.5}px`,
        'margin-top': `${avatarSize / 1.5}px`,
        position: 'absolute',
      }"
    >
      mdi-loading
    </v-icon>
    <v-icon
      v-else-if="showWarn"
      :style="{
        'font-size': `${overlapIconSize}px`,
        'margin-left': `${-avatarSize / 2.5}px`,
        'margin-top': `${avatarSize / 1.5}px`,
        position: 'absolute',
      }"
      :color="overlapIconColor"
      >mdi-alert
    </v-icon>
  </div>
</template>

<script>
export default {
  props: {
    avatarColor: {
      type: String,
      default: 'secondary',
    },
    initialsColor: {
      type: String,
      default: 'primary',
    },
    initialsSize: Number,
    avatarSize: String,
    iconSize: String,
    isGroup: Boolean,
    userAvatar: String,
    userName: String,
    userRole: String,
    showWarn: Boolean,
    overlapAvatarColor: {
      type: String,
      default: 'primary',
    },
    overlapIconColor: {
      type: String,
      default: 'warning',
    },
    overlapAvatarSize: {
      type: String,
      default: '25',
    },
    overlapIconSize: {
      type: String,
      default: '20',
    },
    isDisabledOrDeleted: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.spin {
  animation: spin 0.9s linear infinite;
  transform-origin: center center;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* para simular el grosor */
.loading-icon {
  filter: drop-shadow(0 0 1px currentColor);
}

/* Avatar de un grupo deleted: mostrar tachado con una diagonal */
.custom-avatar-wrapper {
  position: relative;
  display: inline-block;
}

.custom-avatar-disabled {
  opacity: 0.6;
}

.custom-avatar-diagonal {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.custom-avatar-diagonal::before {
  content: '';
  position: absolute;
  width: 140%;
  height: 2px;
  background-color: rgba(0, 0, 0, 0.4);
  top: 50%;
  left: -20%;
  transform: rotate(-45deg);
}
</style>
